const urlRegexp =
  /^\/purchase\/([0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})/i;

export default class Storage {
  constructor(pathname) {
    this.pathname = pathname;
  }

  get id() {
    const md = this.pathname.match(urlRegexp);

    if (!md) {
      return null;
    }

    const [, id] = md;

    return id;
  }

  get key() {
    const { id } = this;

    if (id === null) {
      return null;
    }

    return ['purchase', id].join(':');
  }

  get email() {
    if (!this.key) {
      return '';
    }

    return localStorage.getItem(this.key);
  }

  save(email) {
    if (!this.key) {
      return;
    }

    localStorage.setItem(this.key, email);
  }

  reset() {
    if (!this.key) {
      return;
    }

    localStorage.removeItem(this.key);
  }
}
